{
  "corpusVersion": "sha256:020711c503e014d4ca6afd6898f4a17e0a6a1e72931d4d90ce2f98c30dbd7a0a",
  "diagnostics": [
    {
      "prompt": "tense spy drama",
      "resultCount": 49,
      "status": "kept",
      "surface": "homepageHero",
      "topScore": 0.6286030619938279,
      "topSlug": "betrayal-2026"
    },
    {
      "prompt": "character-first mysteries",
      "resultCount": 20,
      "status": "kept",
      "surface": "homepageHero",
      "topScore": 0.5461078939716021,
      "topSlug": "the-marlow-murder-club-2024"
    },
    {
      "prompt": "90s-style sitcom",
      "resultCount": 13,
      "status": "kept",
      "surface": "homepageHero",
      "topScore": 0.4996844141238129,
      "topSlug": "adults-2025"
    },
    {
      "prompt": "warm workplace comedy",
      "resultCount": 40,
      "status": "kept",
      "surface": "homepageLowerPromo",
      "topScore": 0.6285327234937214,
      "topSlug": "not-suitable-for-work-2026"
    },
    {
      "prompt": "dark comedy about loss",
      "resultCount": 25,
      "status": "kept",
      "surface": "homepageLowerPromo",
      "topScore": 0.5859386595393249,
      "topSlug": "shrinking-2023"
    },
    {
      "prompt": "country-house intrigue",
      "resultCount": 14,
      "status": "kept",
      "surface": "homepageLowerPromo",
      "topScore": 0.539111688365831,
      "topSlug": "the-party-2026"
    },
    {
      "prompt": "murder mystery small town",
      "resultCount": 50,
      "status": "kept",
      "surface": "homepageLowerPromo",
      "topScore": 0.5712084635286171,
      "topSlug": "the-marlow-murder-club-2024"
    },
    {
      "prompt": "slow-burn conspiracy thriller",
      "resultCount": 34,
      "status": "kept",
      "surface": "shows-like-bottom",
      "topScore": 0.5526985364983352,
      "topSlug": "inside-the-circle-2026"
    },
    {
      "prompt": "character-first mystery",
      "resultCount": 15,
      "status": "kept",
      "surface": "shows-like-bottom",
      "topScore": 0.5148898057779674,
      "topSlug": "the-marlow-murder-club-2024"
    },
    {
      "prompt": "sharp workplace comedy",
      "resultCount": 38,
      "status": "kept",
      "surface": "shows-like-bottom",
      "topScore": 0.6114644628517727,
      "topSlug": "not-suitable-for-work-2026"
    },
    {
      "prompt": "atmospheric supernatural drama",
      "resultCount": 31,
      "status": "kept",
      "surface": "shows-like-bottom",
      "topScore": 0.54980055500249,
      "topSlug": "agent-from-above-2026"
    }
  ],
  "generatedAt": "2026-11-04T13:08:26.674Z",
  "minScore": 0.44,
  "prompts": {
    "homepageHero": [
      "tense spy drama",
      "character-first mysteries",
      "90s-style sitcom"
    ],
    "homepageLowerPromo": [
      "warm workplace comedy",
      "dark comedy about loss",
      "country-house intrigue",
      "murder mystery small town"
    ],
    "shows-like-bottom": [
      "slow-burn conspiracy thriller",
      "character-first mystery",
      "sharp workplace comedy",
      "atmospheric supernatural drama"
    ]
  },
  "version": 1
}
